export default __webpack_public_path__ + "static/media/GRINTECH_Reverse_01_full-removebg2.31144510.png";